import UserCreate from "./create"

export default UserCreate
